import React, { useEffect, useRef, useState } from 'react';
import './PaymentHistory.css';
import axios from 'axios';
import { API_BASE_URL } from '../../../Constants/ApiEndpoints';
import AddPaymentComponent from '../../../CommonComponents/AddPaymentComponent';
import RefundComponent from '../../../CommonComponents/RefundComponent';
import { dateTimeFormatter2 } from '../../../CommonComponents/Utils/DateTimeFormatter';
import OngoingChargesReceipt from '../../../CommonComponents/Invoice Receipts/OngoingChargesReceipt';

const PaymentHistory = ({ patient, ipInvoices, fetchInvoices,error,loading,onPaymentSubmit  }) => {
  const [expandedInvoiceId, setExpandedInvoiceId] = useState(null);

  const [showPaymentComponent, setShowPaymentComponent] = useState(false);
  const [showRefundComponent, setShowRefundComponent] = useState(false);

  const [selectedInvoice, setSelectedInvoice] = useState(null);

  // For printing invoices
  const [printInvoice, setPrintInvoice] = useState(null);
  const componentRef = useRef();

  useEffect(() => {
    if (printInvoice) {
      setTimeout(() => {
        if (componentRef.current) {
          window.print();
          setPrintInvoice(null);
        }
      }, 100);
    }
  }, [printInvoice]);

  const handlePrintAll = (e) => {
    if (e) e.stopPropagation();
    if (ipInvoices && ipInvoices.length > 0) {
      setPrintInvoice(ipInvoices[0]);
    } else {
      window.print();
    }
  };

  const handlePrintSingle = (inv, e) => {
    if (e) e.stopPropagation();
    setPrintInvoice(inv);
  };

  const openPaymentComponent = (invoice) => {
    setSelectedInvoice(invoice);
    setShowPaymentComponent(true);
  };

  const closePaymentComponent = () => {
    setShowPaymentComponent(false);
    setSelectedInvoice(null);
  };

  const handlePaymentSubmit = (paymentData) => {
    console.log("Payment submitted for invoice:", selectedInvoice.invoiceId, paymentData);
    fetchInvoices(); // Reload the invoices after a successful payment
    onPaymentSubmit();
  };

  const openRefundComponent = (invoice) => {
    setSelectedInvoice(invoice);
    setShowRefundComponent(true);
  };

  const closeRefundComponent = () => {
    setShowRefundComponent(false);
    setSelectedInvoice(null);
  };

  const handleRefundSubmit = (refundData) => {
    console.log("Payment submitted for invoice:", selectedInvoice.invoiceId, refundData);
    fetchInvoices(); // Reload the invoices after a successful payment
  };

  const toggleInvoice = (invoiceId) => {
    setExpandedInvoiceId(prev => (prev === invoiceId ? null : invoiceId));
  };

  if (loading) return <p>Loading invoices...</p>;
  if (error) return <p>Error: while loading invoices {error}</p>;

  return (
    <div className="payment-history-container">
      <h2 className="payment-title">💳 Payments</h2>

      <div className="payment-header-row">
        <h3 className="payment-subheading">🧾 Payment History</h3>
        <div className="payment-actions">
          <button className="action-btn">📝 Add Notes</button>
          <button className="action-btn" onClick={handlePrintAll}>🖨️ Print All</button>
        </div>
      </div>

      {printInvoice && (
        <div className="print-area">
          <OngoingChargesReceipt
            ref={componentRef}
            patient={patient}
            ipInvoices={ipInvoices}
            invoice={printInvoice}
          />
        </div>
      )}

      <div className="invoice-list">
        {ipInvoices.map((inv, idx) => (
          <div key={idx}>
            <div
              className="invoice-row"
              onClick={() => toggleInvoice(inv.invoiceId)}
              style={{ cursor: 'pointer' }}
            >
              <div className="invoice-left">
                <span className="invoice-number">Invoice #{inv.invoiceId}</span>
                <span className="invoice-name">({inv.name || "Patient"})</span>
              </div>
              <div className="invoice-status">{inv.invoiceStatus}</div>
              <div className="invoice-right">
                <span className="invoice-amount">₹{inv.totalAmount}</span>

                <button
                  className="icon-btn" title="Add Payment"
                  onClick={(e) => {
                    e.stopPropagation(); // 👈 Prevents expansion
                    openPaymentComponent(inv);
                  }}
                >
                  💸
                </button>

                <button className="icon-btn" title="Print Receipt" onClick={(e) => handlePrintSingle(inv, e)}>🖨️</button>
              </div>
            </div>

            {showPaymentComponent && selectedInvoice && (
              <AddPaymentComponent
                invoice={selectedInvoice}
                onClose={closePaymentComponent}
                onSubmit={handlePaymentSubmit}
              />
            )}

            {showRefundComponent && selectedInvoice && (
              <RefundComponent
                invoice={selectedInvoice}
                onClose={closeRefundComponent}
                onSubmit={handleRefundSubmit}
              />
            )}

            {expandedInvoiceId === inv.invoiceId && (
              <div className="invoice-details">
                <p><strong>Date:</strong> {dateTimeFormatter2(inv.invoiceTime)}</p>

                <table className="details-table">
                  <thead>
                    <tr>
                      <th>Particulars</th>
                      <th>Description</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>IN PATIENT CHARGES</td>
                      <td></td>
                      <td>₹{inv.totalAmount}</td>
                    </tr>
                  </tbody>
                </table>

                {/* {inv.payments && inv.payments.map((pmt, i) => (
                  <div key={i} className="payment-detail">
                    <p>
                      <strong>{pmt.paymentId}</strong> ₹{pmt.amount} ({pmt.paymentMode}) Received By <strong>{inv.name}</strong> at {new Date(pmt.paymentDate).toLocaleString()}
                    </p>
                  </div>
                ))} */}

                <div className="summary-box">
                  <div className="payment-line">
                    {inv.payments && inv.payments.map((pmt, i) => (
                      <div key={i} style={{ marginBottom: '6px' }}>
                        {pmt.transactionType === 'REFUND' ? (
                          <>
                            <strong style={{color: 'red'}}>🔁 Refund</strong>{' '}
                            <strong>{pmt.paymentId}</strong> ₹{pmt.amount} ({pmt.paymentMode}) Refunded By{' '}
                            <strong>{(pmt.receivedBy || "Staff").toUpperCase()}</strong> at {dateTimeFormatter2(new Date(pmt.paymentDate).toLocaleString())}
                            {pmt.refundReason && (
                              <div style={{ marginLeft: '20px', fontSize: '0.85em', color: '#888' }}>
                                Reason: {pmt.refundReason}
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            <strong style={{color: 'green'}}>✅ Payment</strong>{' '}
                            <strong>{pmt.paymentId}</strong> ₹{pmt.amount} ({pmt.paymentMode}) Received By{' '}
                            <strong>{(pmt.receivedBy || "Staff").toUpperCase()}</strong> at {dateTimeFormatter2(new Date(pmt.paymentDate).toLocaleString())}
                          </>
                        )}
                      </div>
                    ))}
                  </div>

                  <div className="amount-summary">
                    <div className="summary-row">
                      <span>Total Amount:</span>
                      <span>₹{inv.totalAmount}</span>
                    </div>
                    <div className="summary-row">
                      <span>Paid Amount:</span>
                      <span>₹{inv.amountPaid}</span>
                    </div>
                    {inv.payments && inv.payments.some(p => p.transactionType === 'REFUND') && (
                      <div className="summary-row" style={{color: 'red'}}>
                        <span>Total Refunded:</span>
                        <span>₹{inv.payments.filter(p => p.transactionType === 'REFUND').reduce((sum, p) => sum + p.amount, 0)}</span>
                      </div>
                    )}
                    <div className="summary-row">
                      <span>Due:</span>
                      <span>₹{(inv.invoiceStatus === 'FULLY_REFUNDED') ? 0 : (inv.totalAmount - inv.amountPaid)}</span>
                    </div>
                  </div>
                </div>


                <button className="cancel-btn" onClick={() => setExpandedInvoiceId(null)}>Collapse</button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentHistory;
